<template>
  <div
    class="h-screen overflow-hidden bg-cover bg-center"
    :data-theme="company?.cp_theme"
  >
    <div class="h-screen overflow-auto bg-gray-100">
      <navbar :class="{ hidden: currentRouteIsProposal }" />
      <div class="container mx-auto">
        <router-view></router-view>
      </div>
      <v-footer></v-footer>
    </div>
  </div>
</template>
<script>
import Navbar from "../ClientPortal/client_auth/components/Navbar.vue"
import VFooter from "../ClientPortal/client_auth/components/VFooter.vue"

export default {
  name: "PortalBillingApp",
  components: { VFooter, Navbar },
  data() {
    return {
      company: window.FinancialCents.company || null,
    }
  },
  computed: {
    currentRouteIsProposal() {
      return this.$route.name === "proposal"
    },
  },

  mounted() {
    if (window.FinancialCents?.company?.name) {
      this.$pageTitle(window.FinancialCents.company.name)
    }
  },

  unmounted() {
    this.$resetPageTitle()
  },
}
</script>
